module.exports = __webpack_public_path__ + "assets/img/38_376_big.e0f77de2.jpg";